import { createFileRoute } from '@tanstack/react-router';
import { JourneysGoalHandoff } from '@/pages/workspaces/goals/[goalId]/routing';
import { GoalsRoute, ShowGoalsGate } from './-goals-route';

/** A goal's overview. Forwards to its Hydra page while the rollout flag is on. */
function JourneysGoalRoute() {
  const { goalId } = Route.useParams();

  return (
    <ShowGoalsGate>
      <JourneysGoalHandoff goalId={goalId} tab="overview">
        <GoalsRoute />
      </JourneysGoalHandoff>
    </ShowGoalsGate>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId')({
  component: JourneysGoalRoute,
});
